import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/channelCashierPay",
  component: function component() {
    return import("../../../views/cashier/cashierPay.vue");
  },
  name: "cashierPay",
  meta: {
    title: "收银台",
    foot: true
  }
}];